<template>

  <div>

    <t-dialog-duplicate v-if="formDuplicateShow" :origin="formDuplicate.origin" :path-server="currentPage.path"
                        :form-error="formDuplicateError"
                        dialog-id="modal-duplicate-rule"
                        v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onFlowDuplicated">

      <template #default="{status}">
        <t-input hide-label :status="status" v-model="formDuplicate.processFlowStepId" hidden/>
        <t-input hide-label :status="status" v-model="formDuplicate.processFlowStepRuleId" hidden/>
        <t-input label="Nome da nova Regra" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>
    </t-dialog-duplicate>

    <b-modal @hidden="getList" no-close-on-backdrop no-close-on-esc size="lg" v-model="modalCustomer"
             id="modal-production-process-flow-step-rule-customer"
             hide-footer
             :title="'Clientes da tolerância: ' + modalCustomerName">

      <ProcessFlowStepRuleCustomer  v-if="modalCustomer" :foreign-key="modalCustomerProcessFlowStepRuleId"/>

    </b-modal>

    <ProcessFlowStepRuleDialog :command="command"
                               :foreign-key="foreignKey"
                               :primary-key="form.processFlowStepRuleId"
                               @onSubmit="onProcessFlowStepRuleDialog"/>




    <t-form-list
        sortable hide-header
        :generalErrors="generalErrors"
        :items="itemsFilter" :fields="fields" :command="command" :user-auth="userAuth" :status="status"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded" :path="path"
        primary-key-column="processFlowStepRuleId" :primary-key="form.processFlowStepRuleId"
        :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
        @onSubmit="onSubmit" @onItemRead="openStepRuleReadItem" @onItemDelete="onItemDeleteDefault">


      <!--      <template #item(orderList)="{item}">
              <span class="badge badge-pill badge-light bg-light">{{ item.orderList }} º</span>
            </template>-->

      <template #list-content="{item,index}">

        <b-col cols="12">

          <span v-if="item.typeAnalysis !== FlowStepRuleAnalysisType.type.TOLERANCE"
                class="badge badge-pill badge-light bg-light">
            {{ ++index }}ª Prioridade
          </span>
          <span v-else class="badge badge-pill badge-info bg-info">
            Tolerância
          </span>

          <br/>

          <b-row class="mt-1">

            <b-col cols="6">
              <h5>{{ item.name }}</h5>
              <h6 v-if="item.groupProductId > 0">Aplicável grupo: {{ item.groupProduct }}</h6>
            </b-col>


            <b-col cols="6" class="text-right" v-if="item.typeAnalysis !== FlowStepRuleAnalysisType.type.TOLERANCE">
              <span v-if="item.typeActionRule === FlowStepRuleActionType.type.GO_TO_STEP"><b> Ir para etapa: {{
                  item.goStep
                }}</b><br/></span>
              <span v-else-if="item.typeActionRule === FlowStepRuleActionType.type.FINISH_WITH_ERROR"><b>Finalizar com erro: {{
                  item.statusProduction
                }}</b><br/></span>
              <span v-else-if="item.typeActionRule === FlowStepRuleActionType.type.CHANGE_STATUS_OPERATIONAL"><b>Alterar status: {{
                  item.statusProduction
                }}</b><br/></span>
              <span v-else-if="item.typeActionRule === FlowStepRuleActionType.type.BLOCK"><b>Bloquear e não permitir avançar</b><br/></span>

              <span v-if="item.requiredTypeNonConformance">Exigir escolha de não conformidade pelo operador<br/></span>

              <span
                  v-else-if="!item.requiredTypeNonConformance && item.typeNonConformanceId !== null && item.typeNonConformanceId > 0"> Aplicar não conformidade automaticamente: <b> {{
                  item.typeNonConformance
                }}</b></span>

            </b-col>

          </b-row>


        </b-col>


      </template>

      <template #append-default-buttons="{item}">
        <b-button @click="openDialogDuplicate(item.processFlowStepRuleId, item.name)"
                  class="opacity-6-hover"
                  v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                  title="Duplicar regra">
          <b-icon-files variant="primary"/>
        </b-button>

        <t-button @click="openModalCustomer(item.processFlowStepRuleId, item.name)"
                  small
                  class="mt-1 mr-2"
                  v-if="userAuth.validation.validationCreate && item.typeAnalysis === FlowStepRuleAnalysisType.type.TOLERANCE" v-b-tooltip.hover.ds500
                  title="Clientes desta tolerância">
          <b-icon-people/> Clientes

          <div class="mr-1 badge badge-sm badge-pill bg-warning text-black-50" style="right: -3px; top:-7px;"
               v-if="item.qtyCustomers > 0">{{ item.qtyCustomers }}
          </div>
        </t-button>



      </template>

      <template #list-footer="{item}">

        <b-card class="bg-transparent mt-0 pt-0" body-class="mt-0 pt-0">

          <div v-if="item.typeAnalysis !== FlowStepRuleAnalysisType.type.TOLERANCE"
               class="pt-1 pl-3 alert alert-warning"
               style="border-bottom-right-radius: 0px; border-bottom-left-radius: 0px; margin-bottom: -3px; padding-bottom: 5px">
            <div v-if="item.typeApplication === 1">

              <b-icon-ui-checks/>
              Aplicar quando <b>todos</b> critérios forem atingidos:
            </div>
            <div v-else>
              <b-icon-ui-checks-grid/>
              Aplicar quando <b>qualquer</b> critério for atingido:
            </div>
          </div>

          <b-list-group
              v-if="item.typeAnalysis === FlowStepRuleAnalysisType.type.FIELD || item.typeAnalysis === FlowStepRuleAnalysisType.type.TOLERANCE">

            <b-list-group-item v-for="condition in item.conditions" :key="condition.processFlowStepRuleFieldId">
              {{ ConditionType.getConditionRuleName(condition) }}
            </b-list-group-item>

          </b-list-group>

          <b-list-group v-else>

            <b-list-group-item>

              Status operacional for igual a: <b>{{ item.analysisStatusProduction }}</b>

            </b-list-group-item>

          </b-list-group>


        </b-card>

      </template>

      <div class="d-flex align-items-end mb-2">

        <t-button class="ml-1"  @click="openStepRuleInsert">{{ t('insert') }} {{ currentPage.singularTitle }}</t-button>

        <div class="ml-3">
          <small class="mr-2">Filtrar</small>
          <b-form-radio-group
              v-model="filter"
              :options="filterOptions"
              size="sm"
              buttons
              button-variant="outline-focus"
          />
        </div>

      </div>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import ProcessFlowStepRuleDialog from "@/views/modules/production/ProcessFlow/ProcessFlowStepRuleDialog";
import VarType from "@/model/types/resource/VarType";
import ConditionType from "@/model/types/resource/FieldConditionType";
import InputType from "@/model/types/resource/InputType";
import FlowStepRuleActionType from "@/model/types/modules/production/FlowStepRuleActionType";
import ui from "@/assets/scripts/ui";
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import FlowStepRuleAnalysisType from "@/model/types/modules/production/FlowStepRuleAnalysisType";
import ProcessFlowStepRuleCustomer from "@/views/modules/production/ProcessFlow/ProcessFlowStepRuleCustomer.vue";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {ProcessFlowStepRuleCustomer, tFormList, ProcessFlowStepRuleDialog, TDialogDuplicate},
  name: 'ProcessFlowStepRule',
  data() {
    return {
      FlowStepRuleAnalysisType,
      InputType,
      VarType,
      ConditionType,
      FlowStepRuleActionType,
      path: "production/process-flow-step-rule", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "processFlowStepId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "processFlowStepRuleId", keyDelete: "processFlowStepRuleId"},
      ],
      form: {
        processFlowStepId: this.foreignKey,
        processFlowStepRuleId: 0,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        codeGeneratorPrefix: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      formDuplicateShow: false,
      formDuplicate: {
        processFlowStepId: 0,
        processFlowStepRuleId: 0,
        changeName: "",
        origin: "",
      },
      formDuplicateError: {
        name: "",
      },
      filter: 'all',
      filterOptions: [
        {text: 'Todos', value: 'all'},
        {text: 'Regras', value: 'rules'},
        {text: 'Tolerâncias', value: 'tolerances'}
      ],
      modalCustomer: false,
      modalCustomerName: "",
      modalCustomerProcessFlowStepRuleId: 0,
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    },
    itemsFilter() {

      if (!Array.isArray(this.items)) {
        return []
      }
      switch (this.filter) {
        case 'rules':
          return this.items.filter(
              item => item.typeAnalysis !== FlowStepRuleAnalysisType.type.TOLERANCE
          )
        case 'tolerances':
          return this.items.filter(
              item => item.typeAnalysis === FlowStepRuleAnalysisType.type.TOLERANCE
          )
        default:
          // 'todos'
          return this.items
      }
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.defaultForm()
      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

      this.listIsLoaded = true

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.processFlowStepRuleId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openStepRuleInsert() {

      this.form.processFlowStepRuleId = 0
      this.command = 'insert'

      setTimeout(() => {
        this.openDialogForm('modal-process-flow-step-rule')
      }, 200)

    },
    openStepRuleReadItem(id) {

      this.form.processFlowStepRuleId = id
      this.command = 'update'

      setTimeout(() => {
        this.openDialogForm('modal-process-flow-step-rule')
      }, 200)


    },

    async onProcessFlowStepRuleDialog() {

      //Atualiza a listagem
      await this.getList()

    },

    openDialogDuplicate(id, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.processFlowStepId = this.foreignKey
      this.formDuplicate.processFlowStepRuleId = id
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = ""

      this.openDialogForm('modal-duplicate-rule')

    },

    onFlowDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicada", "Nova regra <b>" + item.name + "</b> duplicada com sucesso!", "success", "b-toaster-top-center", true)

      this.getList()
    },
    openModalCustomer(id, name) {
      this.modalCustomer = true
      this.modalCustomerName = name
      this.modalCustomerProcessFlowStepRuleId = id
    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
